(function () {
	document.addEventListener('shopify:section:load', function () {
		const slider = new Swiper('.js-media-list', getSliderSettings);

		const subSlider = new Swiper('.js-media-sublist', getSubSliderProductSettings);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 100)
	});
})();


document.addEventListener("DOMContentLoaded", function() {
	var stickyAddToCart = document.querySelector('.sticky-addtocart-wrapper');

	function toggleStickyAddToCart() {
		var scrollY = window.scrollY || window.pageYOffset;
		var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;



		if (screenWidth > 768) {
			// Check if the user is 500px away from the bottom
			if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 500)) {
			stickyAddToCart.classList.add('hidden');
			}
		}

		
		// Check if the user has scrolled more than 300px from the top
		if (scrollY > 1200) {
			stickyAddToCart.classList.remove('hidden');
			} else {
			stickyAddToCart.classList.add('hidden');
		}

		if (screenWidth > 768) {
			// Check if the user is 500px away from the bottom
			if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 500)) {
			stickyAddToCart.classList.add('hidden');
			}
		}
	}

	// Attach the scroll event listener
	window.addEventListener('scroll', toggleStickyAddToCart);

	// Initial check on page load
	toggleStickyAddToCart();
});
